export const AUTOCOMPLETE_DEFAULTS = {
  dataType: 'json',
  minChars: 3,
  showNoSuggestionNotice: true,
  noSuggestionNotice: 'Lo sentimos, pero no hay resultados.',
  preserveInput: true,
  autoSelectFirst: true,
  triggerSelectOnValidInput: false,
  preventBadQueries: false,
  tabDisabled: true
};